const SEXOS = [
	{ value: "m" , label: "Masculino", identifier:"masculino" },
  { value: "f" , label: "Feminino", identifier:"feminino"  }
];

export default SEXOS;



// WEBPACK FOOTER //
// ./src/data/Sexos.js